import { LeaseCarDataResponse, LeaseCarDataResponseOccasion } from 'types';

/**
 * Determines if the lease car is a flex
 * Checks if the offerType in privateLeaseData exists and is equal to 'flex' (not case sensitive). For new cars, the
 * field 'offerType' is normally absent.
 * @param leaseCarData object containing privateLeaseData of type PrivateLeaseData or PrivateLeaseDataOccasion
 * @returns true for an occasion and false for a new car
 */
export const isCarFlex = (
	leaseCarData: LeaseCarDataResponse | LeaseCarDataResponseOccasion
): leaseCarData is LeaseCarDataResponseOccasion => {
	if (
		'targetMarkets' in leaseCarData.privateLeaseData &&
		leaseCarData.privateLeaseData.targetMarkets.includes('B2CFlex')
	) {
		return true;
	}
	return false;
};
